"use strict";
// Feature flags fetched from prom-customer-portal-feature-flag-prod on 29.09.2022
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlag = void 0;
var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["MatchingProfile_EmailSendout"] = "MatchingProfile_EmailSendout";
    FeatureFlag["Auth_2FA"] = "Auth_2FA";
    FeatureFlag["Mercury"] = "Mercury";
    FeatureFlag["SupportWidget_Enable"] = "SupportWidget_Enable";
    FeatureFlag["MatchingProfile_AlwaysNonTedBox"] = "MatchingProfile_AlwaysNonTedBox";
    FeatureFlag["Interactions_ShareWithGuestUsers"] = "Interactions_ShareWithGuestUsers";
    FeatureFlag["MatchingProfile_BuyerFilter"] = "MatchingProfile_BuyerFilter";
    FeatureFlag["MatchingProfile_ACL"] = "MatchingProfile_ACL";
    FeatureFlag["InviteTeammates"] = "InviteTeammates";
    FeatureFlag["Users_Webhooks"] = "Users_Webhooks";
    FeatureFlag["Interactions_DocumentLibrary"] = "Interactions_DocumentLibrary";
    FeatureFlag["Rama_Visualizations"] = "Rama_Visualizations";
    FeatureFlag["PDF_Download"] = "PDF_Download";
    FeatureFlag["NonTedBoxes"] = "NonTedBoxes";
    FeatureFlag["Users_Competitors"] = "Users_Competitors";
    FeatureFlag["Interactions_ProcurementLevelComments"] = "Interactions_ProcurementLevelComments";
    FeatureFlag["Workspace_ACL"] = "Workspace_ACL";
    FeatureFlag["Users_IntegrationToken"] = "Users_IntegrationToken";
    FeatureFlag["MatchingProfile_BroadOrNarrowSearchInDocuments"] = "MatchingProfile_BroadOrNarrowSearchInDocuments";
    FeatureFlag["Auth_SSO"] = "Auth_SSO";
    FeatureFlag["Workspace_Archive"] = "Workspace_Archive";
    FeatureFlag["BiddingWorkflow_Tasks"] = "BiddingWorkflow_Tasks";
    FeatureFlag["Users_DeleteUser"] = "Users_DeleteUser";
    FeatureFlag["BiddingWorkflow_Preview"] = "BiddingWorkflow_Preview";
    FeatureFlag["MatchingProfile_HighlightSearchInDocuments"] = "MatchingProfile_HighlightSearchInDocuments";
    FeatureFlag["MatchingProfile_HistoricalTenderFilter"] = "MatchingProfile_HistoricalTenderFilter";
    FeatureFlag["CustomerPortal_Release"] = "CustomerPortal_Release";
    FeatureFlag["KeywordSearch"] = "KeywordSearch";
    FeatureFlag["KnowledgeBank"] = "KnowledgeBank";
    FeatureFlag["EditableDetailspage"] = "EditableDetailspage";
    FeatureFlag["CustomBidFields"] = "CustomBidFields";
    FeatureFlag["ShowOnlyAwarded"] = "ShowOnlyAwarded";
    FeatureFlag["MicrosoftTeams"] = "MicrosoftTeams";
    FeatureFlag["BidStages"] = "BidStages";
    FeatureFlag["AnalyticsHomepage"] = "AnalyticsHomepage";
    FeatureFlag["AnalyticsOrganisationProfiles"] = "AnalyticsOrganisationProfiles";
    FeatureFlag["DefaultSearchProfile"] = "DefaultSearchProfile";
    FeatureFlag["ByggfaktaSmartLink"] = "ByggfaktaSmartLink";
    FeatureFlag["AnalyticsExpiringContracts"] = "AnalyticsExpiringContracts";
    FeatureFlag["ProductVoice"] = "ProductVoice";
    FeatureFlag["Checklist"] = "Checklist";
    FeatureFlag["BiddingTool_BiddingGPT_CSV"] = "BiddingTool_BiddingGPT_CSV";
    FeatureFlag["BiddingTool_BiddingGPT"] = "BiddingTool_BiddingGPT";
    FeatureFlag["Interactions_ProcurementUsageInProm"] = "Interactions_ProcurementUsageInProm";
    FeatureFlag["ManualBids"] = "ManualBids";
    FeatureFlag["SearchLimit50"] = "SearchLimit50";
    FeatureFlag["Workspace_Export"] = "Workspace_Export";
    FeatureFlag["ByggfaktaPrivate"] = "ByggfaktaPrivate";
    FeatureFlag["MonitoringProfiles"] = "MonitoringProfiles";
    FeatureFlag["Bidspaces"] = "Bidspaces";
    FeatureFlag["MatchingProfile_AdvancedFilters"] = "MatchingProfile_AdvancedFilters";
    FeatureFlag["AnalyticsExpiringContractsLight"] = "AnalyticsExpiringContractsLight";
    FeatureFlag["Release_TaskHighlightPreview"] = "Release_TaskHighlightPreview";
    // Notifications for tender updates
    FeatureFlag["TenderUpdatesDocuments"] = "TenderUpdatesDocuments";
    FeatureFlag["TenderUpdatesDeadline"] = "TenderUpdatesDeadline";
    FeatureFlag["TenderUpdatesAdditions"] = "TenderUpdatesAdditions";
    FeatureFlag["TenderUpdatesAwards"] = "TenderUpdatesAwards";
    FeatureFlag["TenderUpdatesCanceledTender"] = "TenderUpdatesCanceledTender";
    FeatureFlag["TenderUpdatesQuestionDeadline"] = "TenderUpdatesQuestionDeadline";
    FeatureFlag["TenderUpdatesValidityPeriod"] = "TenderUpdatesValidityPeriod";
    FeatureFlag["TenderUpdatesQA"] = "TenderUpdatesQA";
})(FeatureFlag = exports.FeatureFlag || (exports.FeatureFlag = {}));
